export const AUTH_TOKEN = 'auth_token';
export const USER_LOGGED = 'user_logged';
export const USER = 'user';
export const ROLE = 'role';
